import { getVendorAndEmailFromCookies } from './utilfunctions.js';

const invoiceDetailsModule = (() => {
  let isInitialized = false;

  const init = () => {
    if (isInitialized) return;
    isInitialized = true;
  };

  const updateInvoice = (data) => {
    if (!data) return;

    const formatAmount = (amount) => {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: data.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);
    };


    const setText = (id, value) => {
      const el = document.getElementById(id);
      if (el) el.textContent = value || '';
    };

    const setHref = (id, href) => {
      const el = document.getElementById(id);
      if (el && href) el.href = href;
    };

    const {
      amount_paid,
      currency,
      invoice_pdf,
      receipt_pdf,
      invoice_number,
      receipt_number,
      payment_method,
      subscription_period,
      paid_date,
      plan_name,
      manage_subscription_url,
      subtotal,
      tax,
    } = data;

    const formattedAmount = formatAmount(amount_paid || 0);
    const unknown = getI18n('unknown');
    const billingPeriodText = getI18n('billing_period_prefix');






    // Top
    setText('success-amount-paid', formattedAmount);
    setText('success-paid-date', paid_date);
    setHref('success-receipt-pdf', receipt_pdf);
    setHref('success-invoice-pdf', invoice_pdf);
    setText('success-invoice-id', invoice_number || unknown);
    setText('success-payment-method', payment_method || unknown);

    // Bottom
    setText('success-receipt-number-2', receipt_number ? `#${receipt_number}` : '');
    setText('success-period', subscription_period || '');
    setText('success-invoice-id', invoice_number || unknown);
    setText('success-payment-method', payment_method || unknown);
    setHref('success-manage-subscription-url', manage_subscription_url || '#');

    const receiptNumber = receipt_number || '';
    const receiptRow = document.querySelector('#success-receipt-number')?.parentElement;

    if (receiptNumber) {
      setText('success-receipt-number', receiptNumber);
      if (receiptRow) receiptRow.style.display = '';
    } else {
      if (receiptRow) receiptRow.style.display = 'none';
    }


    // Line Items
    const lineItemsContainer = document.getElementById('invoice-line-items');
    if (lineItemsContainer) {
      lineItemsContainer.innerHTML = ''; // clear existing

      if (Array.isArray(data.line_items)) {
        data.line_items.forEach(item => {
          const wrapper = document.createElement('div');
          wrapper.className = 'flex flex-col text-sm pb-2';

          const topRow = document.createElement('div');
          topRow.className = 'flex justify-between font-medium';
          topRow.innerHTML = `
            <span>${item.product_name || item.description || getI18n('default_line_item')}</span>
            <span>${item.unit_amount}</span>
          `;

          const bottomRow = document.createElement('div');
          bottomRow.className = 'text-xs text-left';

          bottomRow.textContent = item.interval === 'month'
            ? getI18n('monthly')
            : item.interval === 'year'
              ? getI18n('yearly')
              : item.interval || '';

          const bottomRow2 = document.createElement('div');
          bottomRow2.className = 'text-xs text-left';
          bottomRow2.textContent = `${billingPeriodText} ${subscription_period}`;


          wrapper.appendChild(topRow);
          wrapper.appendChild(bottomRow);
          wrapper.appendChild(bottomRow2);
          lineItemsContainer.appendChild(wrapper);
        });
      }
    }


    // Subtotal
    setText('success-subtotal', formatAmount(subtotal || 0));



    // Tax (hide row if 0 or null)
    const taxRow = document.getElementById('success-tax-row');
    const subTotalRow = document.getElementById('success-subtotal-row');

    if (tax && tax > 0) {
      setText('success-tax', formatAmount(tax));
      if (taxRow) taxRow.style.display = '';
      if (subTotalRow) subTotalRow.style.display = '';
    } else {
      if (taxRow) taxRow.style.display = 'none';
      if (subTotalRow) subTotalRow.style.display = 'none';
    }


    // Total
    setText('success-total', formattedAmount);

    setText('total-amount-paid', formattedAmount);

    // Update legacy spans
    const amountEls = document.querySelectorAll(
      '#success-amount-paid, .prices-monthly-container span:last-child, .flex.justify-between span:last-child'
    );
    amountEls.forEach(el => el.textContent = formattedAmount);


    const siteName = getSiteName();
    const receiptFromEl = document.getElementById('receiptfromSite');
    if (receiptFromEl) {
      receiptFromEl.innerHTML = `<strong>${siteName}</strong>`;
    }
  };

  const unload = () => {
    isInitialized = false;

    const clearText = (id) => {
      const el = document.getElementById(id);
      if (el) el.textContent = '';
    };

    const clearHref = (id) => {
      const el = document.getElementById(id);
      if (el) el.removeAttribute('href');
    };

    clearText('success-amount-paid');
    clearText('success-paid-date');
    clearHref('success-invoice-pdf');
    clearHref('success-receipt-pdf');
    clearText('success-invoice-id');
    clearText('success-payment-method');
    clearText('success-receipt-number');
    clearText('success-receipt-number-2');
    clearText('success-period');
    clearHref('success-manage-subscription-url');
    clearText('success-subtotal');
    clearText('success-tax');
    clearText('success-total');

    const planNameEl = document.querySelector('.prices-monthly-container span:first-child');
    const amountEls = document.querySelectorAll(
      '#success-amount-paid, .prices-monthly-container span:last-child, .flex.justify-between span:last-child'
    );
    if (planNameEl) planNameEl.textContent = '';
    amountEls.forEach(el => el.textContent = '');
  };

  const fetchInvoiceDetails = async (sessionId, email, vendor, folderId) => {
    const url = getApiUrl('get-checkout-session-details', 'geoapi');
    const siteNameForStripe = getSiteNameForStripe();
    const checkoutBase = getCheckoutBase(); //this is window location url like https://resumeinminutes.com
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, email, siteNameForStripe, checkoutBase, vendor, folderId  }),
    });

    if (!res.ok) {
      if (res.status === 403) {
        throw new Error('PERMISSION_DENIED');
      } else if (res.status === 500) {
        throw new Error('SERVER_ERROR');
      } else {
        throw new Error(`Failed to fetch: ${res.status}`);
      }
    }
    return await res.json();
  };

  const loadInvoiceDetailsFromUrl = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');

    if (!sessionId) {
      console.log('No session_id in URL.');
      return;
    }

    const result = getVendorAndEmailFromCookies();
    if (!result || typeof result !== 'object') {
      const errorHeading=getI18n('permission_error_heading');
      const errorMessage=getI18n('permission_error_message');
      showGenericErrorPlaceholder(errorHeading,errorMessage);
      return;
    }
    const { email, vendor, folderId } = result;


    if (!email) {
      const errorHeading=getI18n('permission_error_heading');
      const errorMessage=getI18n('permission_error_message');
      showGenericErrorPlaceholder(errorHeading,errorMessage),
      console.log('User email not found.');
      return;
    }

    try {
      const sessionData = await fetchInvoiceDetails(sessionId, email, vendor, folderId );
      updateInvoice(sessionData);
    } catch (err) {
      console.log('Failed to fetch or update invoice details:', err);

      // Show specific placeholders based on error type
      if (err.message === 'PERMISSION_DENIED') {
        showPermissionErrorPlaceholder();
      } else {
        showGenericErrorPlaceholder(); // Handles SERVER_ERROR or unknown errors
      }
    }


  };

  const showPermissionErrorPlaceholder = () => {
    const permissionEl = document.getElementById('permission-error-placeholder');
    const invoiceEl = document.getElementById('invoice-details');
    const genericEl = document.getElementById('generic-error-placeholder');

    if (permissionEl && invoiceEl) {
      permissionEl.style.display = 'block';
      invoiceEl.style.display = 'none';
    }
    if (genericEl) {
      genericEl.style.display = 'none';
    }
  };

  const showGenericErrorPlaceholder = (headingText = null, messageText = null) => {
    const genericEl = document.getElementById('generic-error-placeholder');
    const invoiceEl = document.getElementById('invoice-details');
    const permissionEl = document.getElementById('permission-error-placeholder');

    if (genericEl && invoiceEl) {
      genericEl.style.display = 'block';
      invoiceEl.style.display = 'none';
    }

    if (permissionEl) {
      permissionEl.style.display = 'none';
    }

    const headingEl = document.getElementById('generic-error-heading');
    const messageEl = document.getElementById('detailed-error-message');

    if (headingText && headingEl) {
      headingEl.textContent = headingText;
    }

    if (messageText && messageEl) {
      messageEl.textContent = messageText;
    }
  };




  return {
    init,
    unload,
    updateInvoice,
    loadInvoiceDetailsFromUrl,
  };
})();

export default invoiceDetailsModule;
